import React, { useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { ModalBody } from "reactstrap";

export default function AccountDeleteModel({ setModel, handleDelete, response }) {
  const [loading, setLoading] = useState(false);

  const onDeleteAccount = async () => {
    try {
      setLoading(true);
      await handleDelete(); // handleDelete should return a promise
      setModel(false); // close modal on success
    } catch (error) {
      console.error("Failed to delete account:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="add-task">
        <h6>Delete Account</h6>
        <button
          onClick={() => setModel((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt="Close"
          />
        </button>
      </div>

      <ModalBody>
        {response === null ? (
          <div className="text-center">
            <LoginLoaderButton />
            <p className="mt-2">Checking account status...</p>
          </div>
        ) : (
          <>
            <h4>{response?.status ? "" : response?.response?.message}</h4>
            {response?.status ? (
              <p>
                This action will permanently delete your account and all data
                with no recovery option.
              </p>
            ) : (
              <p></p>
            )}
          </>
        )}
      </ModalBody>

      <div
        className="modal-footer "
        style={{ marginBottom: 10, columnGap: "10px", flexWrap: "nowrap" }}
      >
        {response === null ? (
          ""
        ) : response?.status ? (
          <>
            <button
              disabled={loading}
              onClick={() => setModel(false)}
              className="btn no"
            >
              Cancel
            </button>
            <button disabled={loading} onClick={onDeleteAccount} className="btn">
              {loading ? <LoginLoaderButton /> : "Yes"}
            </button>
          </>
        ) : (
          <>
            <button
              disabled={loading}
              onClick={() => setModel(false)}
              className="btn no"
            >
              Close
            </button>
          </>
        )}
      </div>
    </>
  );
}
